import { OffersSliceState } from 'src/core/models'

const offersState: OffersSliceState = {
  offers: {
    loading: false,
    offers: [],
    filteredOffers: [],
    filterText: null
  },
  declineOffer: {
    loading: false,
    success: false
  },
  acceptOffer: {
    loading: false,
    success: false
  },
  sendRequestForProposal: {
    loading: false,
    success: false
  }
}

export { offersState as initialState }
